import { Radio, Space } from "antd";
import { SettingSlider } from "../../../controls/SettingSlider";
import styled from "styled-components";

export const HeaderHeightFeature = ({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: number;
  options: number[];
  onChange: (value: number) => void;
}) => {
  const radioButtonOptions = options.map((option) => ({
    label: option + "%",
    value: option,
  }));

  return (
    <>
      <Radio.Group
        value={value}
        onChange={(e) => onChange(e.target.value as number)}
        options={radioButtonOptions}
        style={{ display: "flex", justifyContent: "space-between" }}
      />
      <Space>
        <CustomRadio checked={!options.includes(value)}>{label}</CustomRadio>
        <SettingSlider
          value={Math.round(value)}
          onChange={(value) => onChange(value)}
          min={5}
          max={25}
          valueSuffix="%"
        />
      </Space>
    </>
  );
};

const CustomRadio = styled(Radio)`
  .ant-radio {
    display: none;
  }
  .ant-radio-label {
    padding: 0 !important;
  }
`;
